import React, { useEffect, useRef } from 'react';
import { Parser } from 'html-to-react';
import utils from "utils";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

import { TextField, Line, EmailField, CheckValidInputs, PhoneField, useInput, AutoComplete, ButtonSmall, LabelSubTitle, Paragraph, Row, MainCond,Center } from 'meitav-uikit';

const PopUpContact = props => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const { UmbracoUtills, rest } = utils;
  const handleReCaptchaVerify = async (actionName) => {
    if (!executeRecaptcha) {
      return false;
    }
    const token = await executeRecaptcha(actionName);
    return token;
  };
  const p = new Parser();
  const phone = useInput(UmbracoUtills.getValueByKey(props.resource, "phone"), '', [MainCond.empty, MainCond.phone]);
  const email = useInput(UmbracoUtills.getValueByKey(props.resource, "email"), '', [MainCond.empty, MainCond.email]);
  const fullName = useInput(UmbracoUtills.getValueByKey(props.resource, "fullName"), '', [MainCond.empty, MainCond.hebrew, MainCond.minLength]);
  const timeToCallBack = useInput(UmbracoUtills.getValueByKey(props.resource, "timeToCallBack"), '', [MainCond.empty]);
  const timeToCallBackList = JSON.parse(UmbracoUtills.getValueByKey(props.resource, "timeToCallBackOptions"));
  const timeToCallBackOptions = [];
  timeToCallBackList.forEach((item, i) => {
    timeToCallBackOptions.push({ text: item, value: i });
  })

  const handleClose = () => {
    if (props.handleClose) {
      props.handleClose();
    }
    window.popupClose();
  }


  const handleCick = async () => {
    const investPolicyGUID = localStorage.getItem("investPolicyGUID");

    if (!CheckValidInputs([phone, email, fullName, timeToCallBack])) {
      return;
    }


    const formData = {};

    formData.phone = phone.value;
    formData.fullName = fullName.value;
    formData.email = email.value;
    formData.timeToCallBack = timeToCallBack.value.text;
    formData.investPolicyGUID = investPolicyGUID;
    formData.source = UmbracoUtills.getValueByKey(props.resource, "sourceType");
    const ContactUstoken = await handleReCaptchaVerify(
      `ContactUs`
    );
    try {
      await rest.post('/api/Manager/ContactUs', {
        data: formData,
        headers: {
          gCaptcha: ContactUstoken,
          action: "ContactUs",
        },
      }).then(res => {
        window.dataLayer.push({
          event: "PM - account",
          eventInfo: {
            action_screen: window.location.pathname,
            process_level: "הרכב תיק ההשקעות",
            action_name: "action_name':'user_clicks_contact_us_in_the_proccess",
          },
        });

        window.popupClose();
        if(props.flagSrc!="lobby")  window.location.href = "/CustomerInvestPolicy";
      })

    } catch (error) {
      console.log("error : " + error);
    }

  };

  return (
     <>
    <Row type='small' className="popupContact">
      <Center><LabelSubTitle>{UmbracoUtills.getValueByKey(props.resource, "title")}</LabelSubTitle></Center>
      <Paragraph align="center">{p.parse(UmbracoUtills.getValueByKey(props.resource, "subTitle"))}</Paragraph>

      <Line gap='small'>
        <TextField id="fullName" {...fullName} />
      </Line>
      <Line gap='small'>
        <EmailField id="email" {...email} />
      </Line>
      <Line gap='small'>
        <PhoneField id="phone" {...phone} />
      </Line>
      <Line gap='small'>
      <AutoComplete id="timeToCallBack"  {...timeToCallBack} options={timeToCallBackOptions} optionText="text" optionValue="value"

    ></AutoComplete>
          </Line>
   
      
      <ButtonSmall text={UmbracoUtills.getValueByKey(props.resource, "submitText")} onClick={handleCick} />
    </Row>
    </>
  );
};

export default PopUpContact;
